import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';
import Marketing from './index';

interface Paths {
  marketing: string;
}

const paths: Paths = {
  marketing: '/marketing',
};

export default [
  <RouteIfRights
    blockedAccountStatuses="demo"
    component={Marketing}
    exact
    key={paths.marketing}
    modules="marketing.service"
    path={paths.marketing}
    rights="admin_shops"
  />,
];
